import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_ds_entity_import_requests_gridService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { statusCodes?: string[], dateFrom?: string, dateTo?: string, projects?: string[], warehouses?: string[], fullTextSearch?: string, singleWarehouse?: string, singleProjectLookupCode?: string, singleProjectName?: string, requestId?: string, projectsExact?: string[], warehousesExact?: string[], dateType?: string, requestIds?: string[] }): 
  Promise<{ result: { RequestId?: string, CreatedOn?: string, ErrorMessage?: string, ModifiedOn?: string, Project?: string, ReferenceCode?: string, RequestXmlSourceFile?: string, StatusCode?: string, Warehouse?: string }[] }> 
  {
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { statusCodes?: string[], dateFrom?: string, dateTo?: string, projects?: string[], warehouses?: string[], fullTextSearch?: string, singleWarehouse?: string, singleProjectLookupCode?: string, singleProjectName?: string, requestId?: string, projectsExact?: string[], warehousesExact?: string[], dateType?: string, requestIds?: string[], $top?: number, $skip?: number }): 
  Promise<{ result: { RequestId?: string, CreatedOn?: string, ErrorMessage?: string, ModifiedOn?: string, Project?: string, ReferenceCode?: string, RequestXmlSourceFile?: string, StatusCode?: string, Warehouse?: string }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { statusCodes?: string[], dateFrom?: string, dateTo?: string, projects?: string[], warehouses?: string[], fullTextSearch?: string, singleWarehouse?: string, singleProjectLookupCode?: string, singleProjectName?: string, requestId?: string, projectsExact?: string[], warehousesExact?: string[], dateType?: string, requestIds?: string[], $keys: string[] }): 
  Promise<{ result: { RequestId?: string, CreatedOn?: string, ErrorMessage?: string, ModifiedOn?: string, Project?: string, ReferenceCode?: string, RequestXmlSourceFile?: string, StatusCode?: string, Warehouse?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      statusCodes?: string[], dateFrom?: string, dateTo?: string, projects?: string[], warehouses?: string[], fullTextSearch?: string, singleWarehouse?: string, singleProjectLookupCode?: string, singleProjectName?: string, requestId?: string, projectsExact?: string[], warehousesExact?: string[], dateType?: string, requestIds?: string[]    }) {
      return false;
    }
}
